(() => {
  const selector = '.jdgm-rev__title, .jdgm-rev__body, .jdgm-rev__prod-link, .jdgm-carousel-item__review-title, .jdgm-carousel-item__review-body, .jdgm-carousel-item__product-title';
  const currentName = (text) => text.replace(/\bnomad\b/gi, (name, offset, source) =>
    /digital\s+$/i.test(source.slice(Math.max(0, offset - 16), offset)) ? name : 'Air'
  );

  function updateText(node) {
    const text = node.nodeValue;
    if (!text || !/\bnomad\b/i.test(text)) return;
    const updated = currentName(text);
    if (updated !== text) node.nodeValue = updated;
  }

  function updateElement(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) updateText(walker.currentNode);
  }

  function updateNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.parentElement?.closest(selector)) updateText(node);
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.matches(selector) || node.closest(selector)) {
      updateElement(node);
    } else {
      node.querySelectorAll(selector).forEach(updateElement);
    }
  }

  updateNode(document.body);
  new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'characterData') updateNode(record.target);
      else record.addedNodes.forEach(updateNode);
    });
  }).observe(document.body, { subtree: true, childList: true, characterData: true });
})();
